module.exports = __webpack_public_path__ + "img/logo-dark.8136162e.png";